<template>
	<section>
        
	</section>
</template>

<script>
export default {
  props: ['user', 'api_prefix', 'subscription_plan'],
  data: function () {
  return {
    loading: true
    }
  },
  created: function()
  {
    
  },
	mounted: function() 
	{
		window.analytics.page('HomeBase');
	},
	methods: 
	{

	}
}
</script>

<style scoped>

</style>